import { ActionIcon } from "@mantine/core";
import { IconLanguage } from "@tabler/icons-react";
import { useState } from "react";
import { translate } from "utils/translate";

type TranslateButtonProps = {
  originalText: string;
  tragetLang: string;
  onTranslated: (translatedText: string) => void;
};

export const TranslateButton = (props: TranslateButtonProps) => {
  const { originalText, tragetLang, onTranslated } = props;
  const [loading, setLoading] = useState(false);

  const doTranslation = async () => {
    setLoading(true);
    translate(originalText, tragetLang).then((res) => {
      onTranslated(res);
      setLoading(false);
    });
  };

  return (
    <ActionIcon
      size={35}
      onClick={doTranslation}
      disabled={originalText.length < 3}
      loading={loading}
    >
      <IconLanguage size={30} />
    </ActionIcon>
  );
};
